export default __webpack_public_path__ + "static/media/vuejs.7bc2f1c7.svg";